let httpConfig = {
    // url: 'http://3.22.184.153/api',
    // url: 'http://futureprize.org:8100/api',
    url: 'http://futureprize.org:8100',
}

module.exports = httpConfig